import React from 'react';
import { Typography, Grid, Card, CardContent, Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from '@mui/material';

const ROISection = () => {
  return (
    <section id="roi" className="whitepaper-section">
      <Typography variant="h2" className="section-title">
        Business Value & ROI
      </Typography>

      <Card className="highlight-card" sx={{ mb: 4, background: 'linear-gradient(135deg, rgba(16,185,129,0.15) 0%, rgba(59,130,246,0.15) 100%)', border: '2px solid rgba(16,185,129,0.4)' }}>
        <CardContent>
          <Typography variant="h4" gutterBottom sx={{ color: '#10b981', fontWeight: 700 }}>
            1,177% Three-Year ROI
          </Typography>
          <Typography variant="body1" sx={{ fontSize: '1.15rem', mb: 3, color: '#e0e7ef' }}>
            Based on composite analysis of Fortune 500 deployments processing 50TB daily security data.
          </Typography>

          <TableContainer component={Paper} sx={{ 
            background: 'rgba(10,34,64,0.6)',
            borderRadius: '16px',
            overflow: 'hidden',
            boxShadow: '0 8px 32px rgba(0,0,0,0.3)',
            border: '1px solid rgba(96,165,250,0.2)'
          }}>
            <Table>
              <TableHead>
                <TableRow sx={{ 
                  background: 'linear-gradient(135deg, rgba(96,165,250,0.2) 0%, rgba(59,130,246,0.15) 100%)',
                  borderBottom: '2px solid rgba(96,165,250,0.3)'
                }}>
                  <TableCell sx={{ 
                    color: '#60a5fa', 
                    fontWeight: 700, 
                    fontSize: '1.1rem',
                    padding: '20px 24px',
                    borderBottom: 'none'
                  }}>Metric</TableCell>
                  <TableCell sx={{ 
                    color: '#60a5fa', 
                    fontWeight: 700, 
                    fontSize: '1.1rem',
                    padding: '20px 24px',
                    textAlign: 'center',
                    borderBottom: 'none'
                  }}>Year 1</TableCell>
                  <TableCell sx={{ 
                    color: '#60a5fa', 
                    fontWeight: 700, 
                    fontSize: '1.1rem',
                    padding: '20px 24px',
                    textAlign: 'center',
                    borderBottom: 'none'
                  }}>Year 2</TableCell>
                  <TableCell sx={{ 
                    color: '#60a5fa', 
                    fontWeight: 700, 
                    fontSize: '1.1rem',
                    padding: '20px 24px',
                    textAlign: 'center',
                    borderBottom: 'none'
                  }}>Year 3</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow sx={{ 
                  '&:hover': { background: 'rgba(96,165,250,0.05)' },
                  transition: 'background 0.2s ease'
                }}>
                  <TableCell sx={{ 
                    color: '#e0e7ef', 
                    fontWeight: 600,
                    fontSize: '1rem',
                    padding: '18px 24px',
                    borderBottom: '1px solid rgba(96,165,250,0.1)'
                  }}>Traditional SIEM Costs</TableCell>
                  <TableCell sx={{ 
                    color: '#ef4444', 
                    fontWeight: 600,
                    fontSize: '1.05rem',
                    padding: '18px 24px',
                    textAlign: 'center',
                    borderBottom: '1px solid rgba(96,165,250,0.1)'
                  }}>$19.71M</TableCell>
                  <TableCell sx={{ 
                    color: '#ef4444', 
                    fontWeight: 600,
                    fontSize: '1.05rem',
                    padding: '18px 24px',
                    textAlign: 'center',
                    borderBottom: '1px solid rgba(96,165,250,0.1)'
                  }}>$25.62M</TableCell>
                  <TableCell sx={{ 
                    color: '#ef4444', 
                    fontWeight: 600,
                    fontSize: '1.05rem',
                    padding: '18px 24px',
                    textAlign: 'center',
                    borderBottom: '1px solid rgba(96,165,250,0.1)'
                  }}>$33.31M</TableCell>
                </TableRow>
                <TableRow sx={{ 
                  '&:hover': { background: 'rgba(96,165,250,0.05)' },
                  transition: 'background 0.2s ease'
                }}>
                  <TableCell sx={{ 
                    color: '#e0e7ef', 
                    fontWeight: 600,
                    fontSize: '1rem',
                    padding: '18px 24px',
                    borderBottom: '1px solid rgba(96,165,250,0.1)'
                  }}>Data Fabric Costs</TableCell>
                  <TableCell sx={{ 
                    color: '#60a5fa', 
                    fontWeight: 600,
                    fontSize: '1.05rem',
                    padding: '18px 24px',
                    textAlign: 'center',
                    borderBottom: '1px solid rgba(96,165,250,0.1)'
                  }}>$6.73M</TableCell>
                  <TableCell sx={{ 
                    color: '#60a5fa', 
                    fontWeight: 600,
                    fontSize: '1.05rem',
                    padding: '18px 24px',
                    textAlign: 'center',
                    borderBottom: '1px solid rgba(96,165,250,0.1)'
                  }}>$8.35M</TableCell>
                  <TableCell sx={{ 
                    color: '#60a5fa', 
                    fontWeight: 600,
                    fontSize: '1.05rem',
                    padding: '18px 24px',
                    textAlign: 'center',
                    borderBottom: '1px solid rgba(96,165,250,0.1)'
                  }}>$10.36M</TableCell>
                </TableRow>
                <TableRow sx={{ 
                  background: 'linear-gradient(135deg, rgba(16,185,129,0.15) 0%, rgba(5,150,105,0.1) 100%)',
                  '&:hover': { background: 'linear-gradient(135deg, rgba(16,185,129,0.2) 0%, rgba(5,150,105,0.15) 100%)' },
                  transition: 'background 0.2s ease'
                }}>
                  <TableCell sx={{ 
                    color: '#10b981', 
                    fontWeight: 700,
                    fontSize: '1.05rem',
                    padding: '20px 24px',
                    borderBottom: '1px solid rgba(16,185,129,0.3)'
                  }}>Annual Savings</TableCell>
                  <TableCell sx={{ 
                    color: '#10b981', 
                    fontWeight: 700,
                    fontSize: '1.15rem',
                    padding: '20px 24px',
                    textAlign: 'center',
                    borderBottom: '1px solid rgba(16,185,129,0.3)'
                  }}>$12.98M <Box component="span" sx={{ fontSize: '0.9rem', color: '#34d399' }}>(66%)</Box></TableCell>
                  <TableCell sx={{ 
                    color: '#10b981', 
                    fontWeight: 700,
                    fontSize: '1.15rem',
                    padding: '20px 24px',
                    textAlign: 'center',
                    borderBottom: '1px solid rgba(16,185,129,0.3)'
                  }}>$17.27M <Box component="span" sx={{ fontSize: '0.9rem', color: '#34d399' }}>(67%)</Box></TableCell>
                  <TableCell sx={{ 
                    color: '#10b981', 
                    fontWeight: 700,
                    fontSize: '1.15rem',
                    padding: '20px 24px',
                    textAlign: 'center',
                    borderBottom: '1px solid rgba(16,185,129,0.3)'
                  }}>$22.95M <Box component="span" sx={{ fontSize: '0.9rem', color: '#34d399' }}>(69%)</Box></TableCell>
                </TableRow>
                <TableRow sx={{ 
                  background: 'linear-gradient(135deg, rgba(16,185,129,0.2) 0%, rgba(5,150,105,0.15) 100%)',
                  '&:hover': { background: 'linear-gradient(135deg, rgba(16,185,129,0.25) 0%, rgba(5,150,105,0.2) 100%)' },
                  transition: 'background 0.2s ease'
                }}>
                  <TableCell sx={{ 
                    color: '#10b981', 
                    fontWeight: 700,
                    fontSize: '1.05rem',
                    padding: '20px 24px',
                    borderBottom: 'none'
                  }}>Cumulative Savings</TableCell>
                  <TableCell sx={{ 
                    color: '#10b981', 
                    fontWeight: 700,
                    fontSize: '1.2rem',
                    padding: '20px 24px',
                    textAlign: 'center',
                    borderBottom: 'none'
                  }}>$12.98M</TableCell>
                  <TableCell sx={{ 
                    color: '#10b981', 
                    fontWeight: 700,
                    fontSize: '1.2rem',
                    padding: '20px 24px',
                    textAlign: 'center',
                    borderBottom: 'none'
                  }}>$30.25M</TableCell>
                  <TableCell sx={{ 
                    color: '#10b981', 
                    fontWeight: 700,
                    fontSize: '1.2rem',
                    padding: '20px 24px',
                    textAlign: 'center',
                    borderBottom: 'none'
                  }}>$53.20M</TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>

          <Grid container spacing={3} sx={{ mt: 3 }}>
            <Grid item xs={12} md={4}>
              <Box className="stat-card">
                <Typography className="stat-value">40-70%</Typography>
                <Typography className="stat-label">Cost Reduction</Typography>
              </Box>
            </Grid>
            <Grid item xs={12} md={4}>
              <Box className="stat-card">
                <Typography className="stat-value">85%</Typography>
                <Typography className="stat-label">Faster Investigations</Typography>
              </Box>
            </Grid>
            <Grid item xs={12} md={4}>
              <Box className="stat-card">
                <Typography className="stat-value">90%</Typography>
                <Typography className="stat-label">Reduced False Positives</Typography>
              </Box>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </section>
  );
};

export default ROISection;
